import { render, staticRenderFns } from "./menuBackgroundImage.vue?vue&type=template&id=66fad0f8&scoped=true"
import script from "./menuBackgroundImage.vue?vue&type=script&lang=js"
export * from "./menuBackgroundImage.vue?vue&type=script&lang=js"
import style0 from "./menuBackgroundImage.vue?vue&type=style&index=0&id=66fad0f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fad0f8",
  null
  
)

export default component.exports